// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__ESudz","bigColWidth":"Table_bigColWidth__2LTdH","biggerColWidth":"Table_biggerColWidth__3Khm4","row":"Table_row__Mw_F2","col":"Table_col__2BbGB"};